export const SET_CLICKED_DATE_EVENTS = 'SET_CLICKED_DATE_EVENTS';

export const setClickedDateEvents = (events) => ({
    type: SET_CLICKED_DATE_EVENTS,
    payload: events,
});
